import { render, staticRenderFns } from "./PaymentServicesAct.vue?vue&type=template&id=830544c8"
import script from "./PaymentServicesAct.vue?vue&type=script&lang=ts"
export * from "./PaymentServicesAct.vue?vue&type=script&lang=ts"
import style0 from "./PaymentServicesAct.vue?vue&type=style&index=0&id=830544c8&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('830544c8')) {
      api.createRecord('830544c8', component.options)
    } else {
      api.reload('830544c8', component.options)
    }
    module.hot.accept("./PaymentServicesAct.vue?vue&type=template&id=830544c8", function () {
      api.rerender('830544c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statics/PaymentServicesAct.vue"
export default component.exports